import {
  PROJECTS_SUCCESS,
  PROJECTS_FAIL,
  FETCH_BATCH_MEDIA_SUCCESS,
  FETCH_BATCH_MEDIA_FAIL,
  FETCH_KILN_DIMENSIONS_SUCCESS,
  FETCH_KILN_DIMENSIONS_FAIL,
  FETCH_BATCH_DATA_SUCCESS,
  FETCH_BATCH_DATA_FAIL,
  FETCH_ADDITIONAL_BATCH_DATA_SUCCESS,
  FETCH_ADDITIONAL_BATCH_DATA_FAIL,
  FETCH_CHARGING_DATA_SUCCESS,
  FETCH_CHARGING_DATA_FAIL,
  FETCH_APPLICATION_DATA_SUCCESS,
  FETCH_APPLICATION_DATA_FAIL,
  API_FETCH_FEEDSTOCK_VERIFICATION_DATA_SUCCESS,
  API_FETCH_FEEDSTOCK_VERIFICATION_DATA_FAIL,
  API_VERIFY_BIOCHAR_DATA_SUCCESS,
  API_VERIFY_BIOCHAR_DATA_FAIL,
  API_FETCH_FLAMING_COMBUSTION_DATA_SUCCESS,
  API_FETCH_FLAMING_COMBUSTION_DATA_FAIL,
  API_FETCH_BIOCHAR_MEASUREMENT_DATA_FAIL,
  API_FETCH_BIOCHAR_MEASUREMENT_DATA_SUCCESS,
  API_FETCH_BULK_DENSITY_DATA_SUCCESS,
  API_FETCH_BULK_DENSITY_DATA_FAIL,
  API_FETCH_UNBURNT_VOLUME_SUCCESS,
  API_FETCH_UNBURNT_VOLUME_FAIL,
  GET_STATIONARY_OR_MOBILE_BIOCHAR_DIESEL_DATA_SUCCESS,
  GET_STATIONARY_OR_MOBILE_BIOCHAR_DIESEL_DATA_FAIL,
  POST_STATIONARY_OR_MOBILE_BIOCHAR_DIESEL_DATA_SUCCESS,
  POST_STATIONARY_OR_MOBILE_BIOCHAR_DIESEL_DATA_FAIL,
  GET_STATIONARY_OR_MOBILE_BIOCHAR_DIESEL_DATA_TOTALS_SUCCESS,
  GET_STATIONARY_OR_MOBILE_BIOCHAR_DIESEL_DATA_TOTALS_FAIL,
  GET_HIGHEST_BIOCHAR_ID_SUCCESS,
  GET_HIGHEST_BIOCHAR_ID_FAIL,
  POST_STATIONARY_OR_MOBILE_BIOCHAR_PETROL_DATA_SUCCESS,
  POST_STATIONARY_OR_MOBILE_BIOCHAR_PETROL_DATA_FAIL,
  GET_STATIONARY_OR_MOBILE_BIOCHAR_PETROL_DATA_SUCCESS,
  GET_STATIONARY_OR_MOBILE_BIOCHAR_PETROL_DATA_FAIL,
  GET_STATIONARY_OR_MOBILE_BIOCHAR_PETROL_DATA_TOTALS_SUCCESS,
  GET_STATIONARY_OR_MOBILE_BIOCHAR_PETROL_DATA_TOTALS_FAIL,
  GET_LPG_BIOCHAR_DATA_TOTALS_SUCCESS,
  GET_LPG_BIOCHAR_DATA_TOTALS_FAIL,
  SET_MEASUREMENT_TYPE_SUCCESS,
  SET_MEASUREMENT_TYPE_FAIL,
  FETCH_NOTES_SUCCESS,
  FETCH_NOTES_FAIL,
  SET_SELECTED_RROJECT_SUCCESS,
  SET_SELECTED_RROJECT_FAIL,
  GET_MEASUREMENT_TYPE_SUCCESS,
  GET_MEASUREMENT_TYPE_FAIL
} from './types';
import {
  API_PROJECTS,
  API_GET_BATCH_MEDIA,
  GET_KILN_DIMENSIONS,
  API_GET_BATCH_DATA,
  API_GET_ADDITIONAL_BATCH_DATA,
  API_FETCH_CHARGING_DATA,
  API_FETCH_APPLICATION_DATA,
  API_FETCH_FEEDSTOCK_VERIFICATION_DATA,
  API_FETCH_FLAMING_COMBUSTION_VERIFICATION_DATA,
  API_VERIFY_BIOCHAR_DATA,
  API_FETCH_BIOCHAR_MEASUREMENT_VERIFICATION_DATA,
  API_FETCH_BULK_DENSITY_VERIFICATION_DATA,
  API_FETCH_UNBURNT_VOLUME_VERIFICATION_DATA,
  API_GET_STATIONARY_OR_MOBILE_BIOCHAR_DIESEL_DATA,
  API_POST_STATIONARY_OR_MOBILE_BIOCHAR_DIESEL_DATA,
  API_GET_STATIONARY_OR_MOBILE_BIOCHAR_DIESEL_DATA_TOTALS,
  API_GET_HIGHEST_BIOCHAR_ID,
  API_POST_STATIONARY_OR_MOBILE_BIOCHAR_PETROL_DATA,
  API_GET_STATIONARY_OR_MOBILE_BIOCHAR_PETROL_DATA,
  API_GET_STATIONARY_OR_MOBILE_BIOCHAR_PETROL_DATA_TOTALS,
  API_GET_BIOCHAR_LPG_DATA_TOTALS,
  SET_MEASUREMENT_TYPE,
  API_FETCH_NOTES,
  GET_MEASUREMENT_TYPE
} from './constants';
import {
  setAlert
} from './alert';
import api from '../util/api';

// Base configs; Authorization is attached centrally in util/api.js
const config = {
  headers: {
    'Content-Type': 'application/json',
  },
};

export const setSelectedProject = data => async dispatch => {
  try {
    dispatch({
      type: SET_SELECTED_RROJECT_SUCCESS,
      payload: data,
    });
  } catch (err) {
    dispatch({
      type: SET_SELECTED_RROJECT_FAIL,
    });
  }
};

// Submit Form Data
// Upload Files
// Fetch Form Data
export const getKilnDimensions = projectKey => async dispatch => {
  try {
    const res = await api().get(GET_KILN_DIMENSIONS + `${projectKey}`, config);
    dispatch(setAlert(res.data.detail, 'success'));
    dispatch({
      type: FETCH_KILN_DIMENSIONS_SUCCESS,
      payload: res.data.formdata,
    });
  } catch (err) {
    dispatch(setAlert(err.response.data.detail, 'error'));
    dispatch({
      type: FETCH_KILN_DIMENSIONS_FAIL,
    });
  }
};

// Get Batch Media
export const getBatchMedia = projectId => async dispatch => {
  try {
    const res = await api().get(API_GET_BATCH_MEDIA + projectId, config);
    dispatch(setAlert(res.data.detail, 'success'));
    dispatch({
      type: FETCH_BATCH_MEDIA_SUCCESS,
      payload: res.data.batchMedia,
    });
  } catch (err) {
    dispatch(setAlert(err.response.data.detail, 'error'));
    dispatch({
      type: FETCH_BATCH_MEDIA_FAIL,
    });
  }
};

// Get Batch Data
export const getBatchData = projectId => async dispatch => {
  try {
    const res = await api().get(API_GET_BATCH_DATA + projectId, config);
    dispatch(setAlert(res.data.detail, 'success'));
    dispatch({
      type: FETCH_BATCH_DATA_SUCCESS,
      payload: res.data.batchdata,
    });
  } catch (err) {
    dispatch(setAlert(err.response.data.detail, 'error'));
    dispatch({
      type: FETCH_BATCH_DATA_FAIL,
    });
  }
};

export const getChargingData = projectId => async dispatch => {
  try {
    const res = await api().get(API_FETCH_CHARGING_DATA + projectId, config);
    dispatch(setAlert(res.data.detail, 'success'));
    dispatch({
      type: FETCH_CHARGING_DATA_SUCCESS,
      payload: res.data,
    });
  } catch (err) {
    dispatch(setAlert(err.response.data.detail, 'error'));
    dispatch({
      type: FETCH_CHARGING_DATA_FAIL,
    });
  }
};

export const getApplicationData = projectId => async dispatch => {
  try {
    const res = await api().get(API_FETCH_APPLICATION_DATA + projectId, config);
    dispatch(setAlert(res.data.detail, 'success'));
    dispatch({
      type: FETCH_APPLICATION_DATA_SUCCESS,
      payload: res.data.biochar_application,
    });
  } catch (err) {
    dispatch(setAlert(err.response.data.detail, 'error'));
    dispatch({
      type: FETCH_APPLICATION_DATA_FAIL,
    });
  }
};

export const getAdditionalBatchData = projectId => async dispatch => {
  try {
    const res = await api().get(
      API_GET_ADDITIONAL_BATCH_DATA + projectId,
      config
    );
    dispatch(setAlert(res.data.detail, 'success'));
    dispatch({
      type: FETCH_ADDITIONAL_BATCH_DATA_SUCCESS,
      payload: res.data.additional_batch_data,
    });
  } catch (err) {
    dispatch(setAlert(err.response.data.detail, 'error'));
    dispatch({
      type: FETCH_ADDITIONAL_BATCH_DATA_FAIL,
    });
  }
};

// Fetch Firebreaks
// Create Project
export const createProject = (farmId, data) => async dispatch => {
  try {
    const res = await api().post(`${API_PROJECTS}/${farmId}`, data, config);
    dispatch(setAlert(res.data.detail, 'success'));
    dispatch({
      type: PROJECTS_SUCCESS,
      payload: res.data.projects,
    });
  } catch (err) {
    dispatch(setAlert(err.response.data.detail, 'error'));
    dispatch({
      type: PROJECTS_FAIL,
    });
  }
};

// Fetch User Projects
export const getProjects = (farmId) => async dispatch => {
  try {
    const res = await api().get(API_PROJECTS + `/${farmId}`, config);
    dispatch(setAlert(res.data.detail, 'success'));
    dispatch({
      type: PROJECTS_SUCCESS,
      payload: res.data.projects,
    });
  } catch (err) {
    dispatch(setAlert(err.response.data.detail, 'error'));
    dispatch({
      type: PROJECTS_FAIL,
    });
  }
};

export const getFeedstockVerificationData = projectId => async dispatch => {
  try {
    const res = await api().get(
      API_FETCH_FEEDSTOCK_VERIFICATION_DATA + projectId,
      config
    );
    dispatch(setAlert(res.data.detail, 'success'));
    dispatch({
      type: API_FETCH_FEEDSTOCK_VERIFICATION_DATA_SUCCESS,
      payload: res.data.feedStockData,
    });
  } catch (err) {
    dispatch(setAlert(err.response.data.detail, 'error'));
    dispatch({
      type: API_FETCH_FEEDSTOCK_VERIFICATION_DATA_FAIL,
    });
  }
};

export const getFlamingCombustionData = projectId => async dispatch => {
  try {
    const res = await api().get(
      API_FETCH_FLAMING_COMBUSTION_VERIFICATION_DATA + projectId,
      config
    );
    dispatch(setAlert(res.data.detail, 'success'));
    dispatch({
      type: API_FETCH_FLAMING_COMBUSTION_DATA_SUCCESS,
      payload: res.data.flamingCombustionData,
    });
  } catch (err) {
    dispatch(setAlert(err.response.data.detail, 'error'));
    dispatch({
      type: API_FETCH_FLAMING_COMBUSTION_DATA_FAIL,
    });
  }
};

export const getBiocharMeasurementData = projectId => async dispatch => {
  try {
    const res = await api().get(
      API_FETCH_BIOCHAR_MEASUREMENT_VERIFICATION_DATA + projectId,
      config
    );
    dispatch(setAlert(res.data.detail, 'success'));
    dispatch({
      type: API_FETCH_BIOCHAR_MEASUREMENT_DATA_SUCCESS,
      payload: res.data.biocharMeasurementData,
    });
  } catch (err) {
    dispatch(setAlert(err.response.data.detail, 'error'));
    dispatch({
      type: API_FETCH_BIOCHAR_MEASUREMENT_DATA_FAIL,
    });
  }
};

export const getBulkDensityData = projectId => async dispatch => {
  try {
    const res = await api().get(
      API_FETCH_BULK_DENSITY_VERIFICATION_DATA + projectId,
      config
    );
    dispatch(setAlert(res.data.detail, 'success'));
    dispatch({
      type: API_FETCH_BULK_DENSITY_DATA_SUCCESS,
      payload: res.data.bulkDensityData,
    });
  } catch (err) {
    dispatch(setAlert(err.response.data.detail, 'error'));
    dispatch({
      type: API_FETCH_BULK_DENSITY_DATA_FAIL,
    });
  }
};

export const getUnburntVolume = projectId => async dispatch => {
  try {
    const res = await api().get(
      API_FETCH_UNBURNT_VOLUME_VERIFICATION_DATA + projectId,
      config
    );
    dispatch(setAlert(res.data.detail, 'success'));
    dispatch({
      type: API_FETCH_UNBURNT_VOLUME_SUCCESS,
      payload: res.data.unburntVolumeData,
    });
  } catch (err) {
    dispatch(setAlert(err.response.data.detail, 'error'));
    dispatch({
      type: API_FETCH_UNBURNT_VOLUME_FAIL,
    });
  }
};

export const verifyBiocharData =
  (projectId, dataType, dataToVerify) => async dispatch => {
    try {
      const res = await api().post(
        API_VERIFY_BIOCHAR_DATA + projectId + `/${dataType}`,
        dataToVerify,
        config
      );
      dispatch(setAlert(res.data.detail, 'success'));
      dispatch({
        type: API_VERIFY_BIOCHAR_DATA_SUCCESS,
      });
    } catch (err) {
      dispatch(setAlert(err.response.data.detail, 'error'));
      dispatch({
        type: API_VERIFY_BIOCHAR_DATA_FAIL,
      });
    }
  };

// Diesel
export const postStationaryBiocharDieselData =
  (formData, type, year, farm, project) => async dispatch => {
    try {
      const { data } = await api().post(
        process.env.REACT_APP_API_URL +
        API_POST_STATIONARY_OR_MOBILE_BIOCHAR_DIESEL_DATA +
        `/${type}/${year}/${farm}/${project}`,
        formData,
        config
      );
      dispatch({
        type: POST_STATIONARY_OR_MOBILE_BIOCHAR_DIESEL_DATA_SUCCESS,
        payload: data,
      });
      dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
      dispatch(setAlert(err.response.data.detail, 'error'));
      dispatch({
        type: POST_STATIONARY_OR_MOBILE_BIOCHAR_DIESEL_DATA_FAIL,
        payload: err.response.data.detail,
      });
    }
  };

export const getStationaryBiocharDieselData =
  (type, year, project) => async dispatch => {
    try {
      const { data } = await api().get(
        process.env.REACT_APP_API_URL +
        API_GET_STATIONARY_OR_MOBILE_BIOCHAR_DIESEL_DATA +
        `/${type}/${year}/${project}`,
        config
      );
      dispatch({
        type: GET_STATIONARY_OR_MOBILE_BIOCHAR_DIESEL_DATA_SUCCESS,
        payload: data,
      });
      dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
      dispatch(setAlert(err.response.data.detail, 'error'));
      dispatch({
        type: GET_STATIONARY_OR_MOBILE_BIOCHAR_DIESEL_DATA_FAIL,
        payload: err.response.data.detail,
      });
    }
  };

export const getStationaryBiocharDieselDataTotals =
  (type, year, project) => async dispatch => {
    try {
      const { data } = await api().get(
        process.env.REACT_APP_API_URL +
        API_GET_STATIONARY_OR_MOBILE_BIOCHAR_DIESEL_DATA_TOTALS +
        `/${type}/${year}/${project}`,
        config
      );
      dispatch({
        type: GET_STATIONARY_OR_MOBILE_BIOCHAR_DIESEL_DATA_TOTALS_SUCCESS,
        payload: data,
      });
      dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
      dispatch(setAlert(err.response.data.detail, 'error'));
      dispatch({
        type: GET_STATIONARY_OR_MOBILE_BIOCHAR_DIESEL_DATA_TOTALS_FAIL,
        payload: err.response.data.detail,
      });
    }
  };

export const geBiocharHighestId = type => async dispatch => {
  try {
    const { data } = await api().get(
      process.env.REACT_APP_API_URL + API_GET_HIGHEST_BIOCHAR_ID + type,
      config
    );
    dispatch({
      type: GET_HIGHEST_BIOCHAR_ID_SUCCESS,
      payload: data,
    });
    // dispatch(setAlert(data.detail, 'success'));
  } catch (err) {
    dispatch(setAlert(err.response.data.detail, 'error'));
    dispatch({
      type: GET_HIGHEST_BIOCHAR_ID_FAIL,
      payload: err.response.data.detail,
    });
  }
};

/* PETROL */

export const postStationaryOrMobileBiocharPetrolData =
  (formData, type, year, farm, project) => async dispatch => {
    try {
      const { data } = await api().post(
        process.env.REACT_APP_API_URL +
        API_POST_STATIONARY_OR_MOBILE_BIOCHAR_PETROL_DATA +
        `/${type}/${year}/${farm}/${project}`,
        formData,
        config
      );
      dispatch({
        type: POST_STATIONARY_OR_MOBILE_BIOCHAR_PETROL_DATA_SUCCESS,
        payload: data,
      });
      dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
      dispatch(setAlert(err.response.data.detail, 'error'));
      dispatch({
        type: POST_STATIONARY_OR_MOBILE_BIOCHAR_PETROL_DATA_FAIL,
        payload: err.response.data.detail,
      });
    }
  };

export const getStationaryOrMobileBiocharPetrolData =
  (type, year, project) => async dispatch => {
    try {
      const { data } = await api().get(
        process.env.REACT_APP_API_URL +
        API_GET_STATIONARY_OR_MOBILE_BIOCHAR_PETROL_DATA +
        `/${type}/${year}/${project}`,
        config
      );
      dispatch({
        type: GET_STATIONARY_OR_MOBILE_BIOCHAR_PETROL_DATA_SUCCESS,
        payload: data,
      });
      dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
      dispatch(setAlert(err.response.data.detail, 'error'));
      dispatch({
        type: GET_STATIONARY_OR_MOBILE_BIOCHAR_PETROL_DATA_FAIL,
        payload: err.response.data.detail,
      });
    }
  };

export const getStationaryOrMobileBiocharPetrolDataTotals =
  (type, year, project) => async dispatch => {
    try {
      const { data } = await api().get(
        process.env.REACT_APP_API_URL +
        API_GET_STATIONARY_OR_MOBILE_BIOCHAR_PETROL_DATA_TOTALS +
        `/${type}/${year}/${project}`,
        config
      );
      dispatch({
        type: GET_STATIONARY_OR_MOBILE_BIOCHAR_PETROL_DATA_TOTALS_SUCCESS,
        payload: data,
      });
      dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
      dispatch(setAlert(err.response.data.detail, 'error'));
      dispatch({
        type: GET_STATIONARY_OR_MOBILE_BIOCHAR_PETROL_DATA_TOTALS_FAIL,
        payload: err.response.data.detail,
      });
    }
  };

export const getLpgBiocharDataTotals = (year, project) => async dispatch => {
  try {
    const { data } = await api().get(
      process.env.REACT_APP_API_URL +
      API_GET_BIOCHAR_LPG_DATA_TOTALS +
      `/${year}/${project}`,
      config
    );
    dispatch({
      type: GET_LPG_BIOCHAR_DATA_TOTALS_SUCCESS,
      payload: data,
    });
    dispatch(setAlert(data.detail, 'success'));
  } catch (err) {
    dispatch(setAlert(err.response.data.detail, 'error'));
    dispatch({
      type: GET_LPG_BIOCHAR_DATA_TOTALS_FAIL,
      payload: err.response.data.detail,
    });
  }
};

export const postMeasurementType = (formData, project) => async dispatch => {
  try {
    const { data } = await api().post(
      process.env.REACT_APP_API_URL + SET_MEASUREMENT_TYPE + `/${project}`,
      formData,
      config
    );
    dispatch({
      type: SET_MEASUREMENT_TYPE_SUCCESS,
      payload: data,
    });
    dispatch(setAlert(data.detail, 'success'));
  } catch (err) {
    dispatch(setAlert(err.response.data.detail, 'error'));
    dispatch({
      type: SET_MEASUREMENT_TYPE_FAIL,
      payload: err.response.data.detail,
    });
  }
};

export const getMeasurementType = project => async dispatch => {
  try {
    const { data } = await api().get(
      process.env.REACT_APP_API_URL + GET_MEASUREMENT_TYPE + `/${project}`,
      config
    );
    dispatch({
      type: GET_MEASUREMENT_TYPE_SUCCESS,
      payload: data,
    });
    dispatch(setAlert(data.detail, 'success'));
  } catch (err) {
    dispatch(setAlert(err.response.data.detail, 'error'));
    dispatch({
      type: GET_MEASUREMENT_TYPE_FAIL,
      payload: err.response.data.detail,
    });
  }
}

// fetch-batch-volumes-and-media-pdf/<projectId>/<batchId>
// Fetch Notes
export const getNotes = projectId => async dispatch => {
  try {
    const { data } = await api().get(
      process.env.REACT_APP_API_URL + API_FETCH_NOTES + '/' + projectId,
      config
    );
    dispatch({
      type: FETCH_NOTES_SUCCESS,
      payload: data.notes,
    });
    dispatch(setAlert(data.detail, 'success'));
  } catch (err) {
    dispatch(setAlert(err.response.data.detail, 'error'));
    dispatch({
      type: FETCH_NOTES_FAIL,
      payload: err.response.data.detail,
    });
  }
};
